<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2022-01-10 15:46:27
 * @LastEditTime: 2022-01-10 16:06:41
-->
<template>
  <footer class="Mfooter">
    <a href="http://wwww.imonment.top" target="_blank">意刻</a> |<a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      > 皖ICP备19001128号-3</a
    >
    <br />
    CopyRight&copy;imonment.top. All rights reseved
  </footer>
</template>

<script>
export default {
  name: "MFooter",
};
</script>

<style lang="less" scoped>
.Mfooter {
  margin: 10px 0;
  text-align: center;
  opacity: 0.8;
  user-select: none;
}
</style>